module.exports = __webpack_public_path__ + "img/T7450-IL.231c742e.jpg";